export default __webpack_public_path__ + "media/images/logofluxod-c411d388c64e5589cb2ccf1c0c594609.png";